module.exports = __webpack_public_path__ + "static/media/Recurso 6logo Total Protect blanco.80bb4558.png";